import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Typography } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles(theme => ({
  button: {
    padding: '2px 10px',
    borderRadius: 25,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: 5,
    border: 'none'
  }
}))

export default React.memo((props) => {
  const classes = useStyles();
  const {
    onClick = () => {},
    icon = 'info-circle',
    children,
    color = '#0073d1',
    backgroundColor = '#c2e1fb',
    disabled = false,
    style = {}
  } = props;

  return (
    <button
      className={classes.button}
      onClick={onClick}
      style={{ backgroundColor: disabled ? '#d1d1d1' : backgroundColor, ...style }}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={icon} size='sm' color={disabled ? '#898989' : color} style={{ marginRight: 5 }}/>
      <Typography variant='body1' color={disabled ? '#898989' : color}>
        {children}
      </Typography>
    </button>
  )
})
